module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_IT-50ec59d6cf4db073219b2b9f0913b357.svg";